export default {"src":"/_next/static/media/facebook.a93c08a7.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};